import {Box} from "@chakra-ui/react";

export const FooterGradients = () => (
    <>
        <Box
            top={'0'}
            position={'absolute'}
            backdropFilter="blur(200px) brightness(0.9)"
            w={'886px'}
            h={'134px'}
            borderRadius={'592px'}
            opacity={'75%'}
            left={'25%'}/>
        <Box
            top={'0'}
            position={'absolute'}
            bg={'radial-gradient(50% 50% at 50% 50%, rgba(94, 148, 255, 0.24) 0%, rgba(49, 94, 255, 0) 100%)'}
            w={'1141px'}
            h={'1141px'}
            borderRadius={'100%'}
            opacity={'60%'}
            left={'383px'}/>
    </>
)